var api = {
    login:'/api/app/auth/loginByPassword',//登录
    loginByEmail:'/api/app/auth/loginByEmail',//验证码登录
    unableLogin:'/merchant/unableLogin/add',//无法登录
    authInfo:'/api/app/auth/info',//查询登录信息
    merchantApply:'/api/app/merchant/apply',//商家申请
    sendCaptcha:'/api/app/auth/sendCaptcha',//发送验证码
    getStaffAuthority: '/system/menu/roleMenuMerchantTreeselect', // 获取用户所拥有的权限
    systemDictData:'/system/dict/data/list',//信息
    getMerchant:'/api/app/merchant/getMerchant',//审核注册详细信息
    platform:'/merchant/data/upload/list',//商家申请时需要的附近信息
    verificationEmail:'/api/app/auth/verificationEmail',//判断验证码是否正确

    messageNum:'/merchant/message/push/messageNum',//首页 消息数量
    noticeList: '/merchant/notice/list', // 首页 公告列表
    bannerPics: '/api/app/banner/list', // 首页 banner轮播图
    
    index:'/merchant/index/index',//首页管理
    messageFailLog:'/merchant/index/messageFailLog',//首页 审核未通过信息
    errorNoticeDetail:'/merchant/index/abnormalDetail',//首页 异常提详情
   
    //配置信息
    manyInfo:'/merchant/many/info',//获取多语言平台配置详细信息
    manyList:'/merchant/many/list',//获取多语言平台配置详细信息
    getInfoByConfigKey:'merchant/many/getInfoByConfigKey',//获取多语言平台配置详情
    configList:'/merchant/config/list',
    selectJpConfigByKey:'/merchant/config/selectJpConfigByKey',//获取平台配置信息
    dictDataType:'/system/dict/data/type/',//获取推送地址
    dictDataList:'/system/dict/data/list',//系统配置 可以查账户列表类型
    //个人中心
    storeList:'/merchant/store/listAll',//店铺管理
    storeListAll:'/merchant/store/listAll',//查询商家店铺列表不分页
    storeEdit:'/merchant/store/edit',//修改店铺信息
    storeInfo:'/merchant/store/info',//店铺详情
    storeEditInfo:'/merchant/store/editGetInfo',//店铺详情--编辑时使用
    getMerchantFileVo: "/platform/merchantStoreFile/getMerchantFileVo", // 查看收费：内存使用情况
    storeAdd:'/merchant/store/add',//添加店铺
    storeEditBackground:'/merchant/store/editBackground',//修改店铺背景图片 首页管理
    storeEditBusiness:'/merchant/store/editBusiness',//修改状态 临时休业 和恢复营业
    storeApplyThaw:'/merchant/store/applyThaw',//申请解约和申请解冻
    storeCloseShop:'/merchant/store/closeShop',//申请关店
    storeWithdraw:'/merchant/store/withdraw',//撤回关店申请
    storeDetermine:'/merchant/store/determine',//店铺确认
    storeRemove:'/merchant/store/remove',//申请删除店铺
    
    merchantInfo:'/merchant/info',//获取商户信息
    merchantEditEmail:'/merchant/editEmail',//修改商户登录主账号邮箱
    merchantEditPassword:'/merchant/editPassword',//设置登录密码
    merchantEdit:'/merchant/edit',//修改商户
    merchantDetemine:'/merchant/determine',//商家确认
    merchantRevoke:'/merchant/revoke',//撤回申请
    merchantApplyThaw:'/merchant/applyThaw',//申请解约和申请解冻
    treeselect:'/system/menu/treeselect',//获取权限节点
    roleAdd:'/merchant/role',//添加角色
    roleInfo:'/merchant/role/',//角色详情
    roleList:'/merchant/role/list',//角色列表
    roleListAll:'/merchant/role/listAll',//角色列表 用于员工页面的下拉选择框的调用
    roleMenuTreeselect:'system/menu/roleMenuTreeselect/',//节点默认选中
    staffAdd:'/merchant/user',//添加员工
    stasffList:'/merchant/user/list',//员工列表
    editStaffEmail: '/merchant/user/updEmail', // 修改用户邮箱
    resetPassword: '/merchant/user/resetPwd', // 修改用户密码
    getStaffInfo:'/merchant/user/',// 获取员工信息 get
    delStaffInfo:'/merchant/user/',// 删除员工信息 DELETE
    settlementList:'/merchant/settlement/record/list',//钱包管理
    settlement:'/merchant/settlement/record/settlement', //提前结算
    applyRechange:'/merchant/settlement/record/applyRechange',//申请充值
    // 个人中心 系统设置
    systemSetting: '/system/user/profile', // 获取登录用户详情
    userResetPwd: "/system/user/resetPwd", // 重置密码

    // 个人中心 统计信息
    flowwaterList: '/merchant/flowwater/list', // 收支明细
    // stockList: 'merchant/stock/list', // 库存统计 列表
    stockList: '/merchant/stock/log', // 新接口 流转明细 列表
    flowwaterInfo:'merchant/flowwater/info',//新接口 5月11日 18:37收支明细那块期初那块的数据接口
    stockInfo:'merchant/stock/info',//新接口 流转明细

    userStatistic: '/merchant/memberStatistics/getMemberStatistics', // 用户统计
    goodsClassStatistic: '/merchant/goodsStatistics/list',// 商品统计 类名交易数据
    mallOrderData:'merchant/transaction/log/mallOrderData',//交易数据-商城订单 5月22日新增
    transactionOrderListLine:'transaction/order/list',//交易数据-商城订单 折线图 5月24日新增
    incomeExpenseData:'merchant/transaction/log/incomeExpenseData',//交易数据-收入与支出 5月24日新增
    transactionProfitLossLine:'transaction/profit/loss/list', //交易数据-收入与支出 折线图 5月24日新增
    profitLossListLine:'merchant/order/profitLoss/list',//交易数据-损益 折线图 5月24日新增
    profitLossListLine2:'merchant/other/profit/loss/list',//交易数据-损益 折线图 5月24日新增
    goodsTypeData:'merchant/transaction/log/goodsTypeData',//交易数据-商品统计-按分类
    goodsDataList:'merchant/transaction/log/goodsData',//交易数据-商品统计-按商品
    goodsSaleStatistic: '/merchant/goodsStatistics/saleList',// 商品统计 商品销售统计
    stockChangeStatistic: '/merchant/goodsStatistics/circulationList', // 商品统计 库存流转统计
    transactionStatistic: '/merchant/transaction/log/getData', // 交易统计 交易数据 表格
    transactionStatistic2: '/merchant/transaction/log/getDataForm', // 交易统计 交易数据 折线图
    costStatistic: '/merchant/transaction/log/getCost', // 交易统计 费用收入、支出统计 type1收入 2 支出
    getMemberStatisticsInfo:'merchant/memberStatistics/getMemberStatisticsInfo',//交易数据 顾客类型 6月3日新增
    transactionGoodsTypeList:'merchant/Transaction/goodsType/list',//交易数据 商品分类折线图
    transactionGoodsDataList:'merchant/transaction/goodsData/list',//交易数据 商品折线图
    transactionMemberDataList:'transaction/member/data/list',//交易数据 用户折线图

    // 个人中心 统计信息 导出
    shouzhiExport: '/merchant/flowwater/export', // 收支明细导出

    dealExport: '/merchant/transaction/log/getDataExport', // 交易统计导出
    dealOutExport: '/merchant/transaction/log/expenditureExport', // 交易统计 支出列表 导出
    dealInExport: '/merchant/transaction/log/incomeExport', // 交易统计 收入列表 导出


    goodsSellByClassExport: 'merchant/goodsStatistics/export', // 商品 类名销售统计 导出
    goodsSellExport: 'merchant/goodsStatistics/saleListExport', // 商品 销售统计 导出
    goodsStockExport: 'merchant/goodsStatistics/circulationListExport', // 商品 库存流转统计 导出

    stockExport: '/merchant/stock/export', // 库存统计导出
    userExport: 'merchant/memberStatistics/export', // 用户统计导出

    // 报表数据
    reportHead: '/common/applePay/reportForm', // 报表头部信息
    reportFinance:'/merchant/reportForm/finance',//平台财务总报告
    reportStockList:'/merchant/reportForm/stockList',//商品库存报告
    reportCirulation:'/merchant/reportForm/otherCirculationList',//商品流转报告
    reportPayment:'/merchant/reportForm/payment',//平台运营收付明细报告兼收款凭证
    reportPaymentDetail:'/merchant/reportForm/paymentDetailed',//平台运营收付明细报告
    reportFormReceipt:'merchant/reportForm/receipt',//收据
    reportFormCredentials:'merchant/reportForm/credentials',//凭证

    // 报表数据 导出
    totalReportExport: 'merchant/reportForm/financeExport', // 财务报表报告
    stockReportExport: 'merchant/reportForm/stockListExport', // 商品库存报告

    goodsChangeReportExport1: 'merchant/reportForm/circulationListExport', // 商品流转报告 总体流转
    goodsChangeReportExport2: 'merchant/reportForm/otherCirculationListExport', // 商品流转报告 其他库存明细

    operationOutInExport: 'merchant/reportForm/paymentExport', // 运营收付凭证报告
    totalOutInDetailExport: 'merchant/reportForm/paymentDetailedExport', // 运营收付总明细
    merchantWithdraw:'merchant/withdraw',//商家撤回申请

    
    //上传接口
    upload:'/api/common/upload',
    merchantUploadFile:'/api/common/merchantUploadFile',//登录后上传接口
    //运营管理
    goodsList:'/merchant/goods/list',//商品列表
    goodsAdd:'/merchant/goods/add',//添加商品
    goodsEdit:'/merchant/goods/edit',//修改商品
    goodsBatch:'/merchant/goods/batch',//批量删除和下架
    goodsRemove:'/merchant/goods/batchOne',// 删除和下架
    goodsApplyThaw:'/merchant/goods/applyThaw',//商品申请解冻
    goodsDetails:'/merchant/goods/goodsDetails',//获取商品详情
    goodsDetailsEdit:'/merchant/goods/goodsDetailsEdit',//获取商品详情--编辑时候用
    goodsDetermine:'/merchant/goods/determine',//商品确认

    editPaymentConfirm:'merchant/store/editPaymentConfirm',//修改支付方式和修改自动接单
    
    couponList:'/merchant/father/list',//优惠券列表
    couponUserList:'/merchant/coupon/list',//优惠券领取列表
    couponAdd:'/merchant/father/add',//新增总优惠券
    conponDetail:'/merchant/father/info',//优惠券详情
    conponEdit:'/merchant/father/edit',//修改优惠券信息
    conponDelete:'/merchant/father/remove',//删除优惠券
    storePushList:'/merchant/store/push/list',//推送内容
    marketList:'/merchant/market/list',//市场接口
    categoryList:'/merchant/category/list',//查询平台分类和店铺分类列表
    categoryAdminList:'/merchant/category/adminList',//商品添加时:查询平台分类或商家分类
    categoryAdd:'/merchant/category/add',//添加分类
    categoryEdit:'/merchant/category/edit',//商品分类修改
    categoryRemove:'/merchant/category/remove',//删除店铺分类
    categoryTransfer:'/merchant/category/transfer',//商品转移
    pushList:'/merchant/push/list',//内容推送列表
    pushAdd:'/merchant/push/add',//新增内容推送
    pushEdit:'/merchant/push/edit',//修改推送内容
    pushBatch: 'merchant/push/batch',// 批量上架、下架
    pushRemove:'/merchant/push/remove',//删除内容推送
    pushInfo:'/merchant/push/info',//内容推送详情
    pushThaw:'/merchant/content/record/add',//推送内容申请解冻
    pushThawConfirm: 'merchant/push/confirm', // 解冻审核被拒绝后，确认结束事件
    brandList:'/platform/brand/listAll',//获取商品品牌
    storePushAdd:'/merchant/store/push/add',//首页管理 添加首页推送
    storePushRemovde:'/merchant/store/push/remove',//删除店铺首页推送
    commentList:'/merchant/comment/list',//评论列表
    commentInfo:'/merchant/comment/info',//商品详情
    commentDelete:'/merchant/comment/applyDelete',//申请删除评论 申诉
    appealList:'/merchant/appeal/list',//查看评论申诉
    appealReturn:'/merchant/appeal',//撤销申诉

    commentExport:'/merchant/comment/export',//评价导出
    commentAppealExport:'/merchant/appeal/export',//评价申述导出
    goodsExport:'/merchant/goods/export',// 商家导出


    //订单管理
    orderList:'/merchant/order/list',//订单列表
    orderInfo:'/merchant/order/info',//订单详情
    otherList:'/merchant/order/otherList',//其他订单列表
    confirmOrder:'/merchant/order/confirmOrder',//确认订单
    refuseOrder:'/merchant/order/refuseOrder',//拒绝
    afterSaleList:'/merchant/afterSale/list',//售后列表 杨
    afterSaleInfo:'/merchant/afterSale/',//售后详情 杨
    afterSaleAgree:'/merchant/afterSale/agree',//同意退款 杨
    afterSaleRefuseRefund:'/merchant/afterSale/refuseRefund',//拒绝退款 杨
    bannerList:'/merchant/banner/list',//广告订单
    bannerAdd:'/merchant/banner/add',//添加广告订单
    bannerEdit:'/merchant/banner/edit',//编辑广告订单
    getFullDays: 'merchant/banner/bannerOrderDate', // 通过广告位id获取哪些天的广告位是满的
    bannerInfo:'/merchant/banner/info',//广告订单详情
    logisticsList:'/merchant/logistics/list',//物流订单列表
    logisticsInfo:'/merchant/logistics/',//物流单详情
    logisticsEdit:'/merchant/logistics/edit',//修改物流单
    inventoryList:'/merchant/productStockInventory/list',//盘点
    inventoryDetail:'merchant/productStockInventory/getDetail',//盘点处理详情
    getHandleProduct:'/merchant/productStockInventory/getHandleProduct',//获取该商家所有盘亏（普通盘亏+特殊盘亏）还未处理完的商品
    handleList:'/merchant/handle/list',//商品处理订单
    confirmAddHandle:'/merchant/handle',//新增商品处理订单
    handleInfo:'/merchant/handle/info',//获取商品处理订单详细信息
    handleProductList:'/merchant/storehouse/product/list',//查询商品处理的商品离别
    
    bannerExport:'/merchant/banner/export',// 购买平台广告导出
    logisticsExport:'/merchant/logistics/export',// 平台物流导出
    afterSaleExport:'/merchant/afterSale/export',// 售后导出
    logisticsGoodsExport:'/merchant/handle/export',// 平台物流->商品处理 导出
    orderExport:'/merchant/order/export',// 导出订单列表 待确认商城订单/待取货商城订单
    orderExportPdf:'/merchant/order/exportPdf',// 导出订单列表 待确认商城订单/待取货商城订单

    otherListExport: 'merchant/order/exportOtherList', // 其他商城订单 导出

    //消息中心
    messageList:'/merchant/message/list',//订单与物流消息
    messagePushList:'/merchant/message/push/list',//系统通知
    feedbackList:'/merchant/feedback/lists',//平台客服（反馈)
    feedbackItemsList:'/merchant/feedback/itemsList',//获取反馈类型
    feedbackInfo:'/merchant/feedback/detail',//反馈详情
    feedbackAdd:'/merchant/feedback/addFeedback',//新增反馈
    feedbackReply:'/merchant/feedback/addFeedbackReply',//恢复反馈
    feedbackClose:'/merchant/feedback/closeFeedback',//反馈关闭
    helpTypeList:'/merchant/helpType/list',//帮助中心列表
    walletExport:'/merchant/settlement/record/export',// 钱包管理导出
    operateLogList:'/member/operateLog/list',//操作日志


    //2022-10-23新开接口
    getAdressBycode:'api/app/area/zipCodeInfo', // 根据邮编获取信息 zipCode
    getProvince: '/api/app/area/getCityList', // 获取 省 不传
    getCityList: '/api/app/area/getAreaList', // 获取 市 传city

    // 2022-11-12新开接口
    entranceAdd: '/merchant/entrance/add', // 店铺入口-新增
    entranceEdit: '/merchant/entrance/edit', // 店铺入口-修改
    entranceInfo: '/merchant/entrance/info', // 店铺入口-详情
    entranceList: '/merchant/entrance/listAll', // 店铺入口-列表
    entranceRemove: '/merchant/entrance/remove', // 店铺入口-删除

    // 2022-11-14新开接口
    editPayment: '/merchant/editPayment', // 修改商家收款方式

    // 2022-11-16新开接口
    deliveryAdd: '/merchant/delivery/add', // 商家配送设置-新增
    deliveryEdit: '/merchant/delivery/edit', // 商家配送设置-修改
    deliveryList: '/merchant/delivery/list', // 商家配送设置-列表
    deliveryInfo: '/merchant/delivery/info', // 新增商家配送设置-详情
    deliveryRemove: '/merchant/delivery/remove', // 新增商家配送设置-删除

    cList: '/merchant/order/cList', // C类订单列表
    serviceOrder: '/merchant/order/serviceOrder', // C类订单-确认送达

    cancelOrderUnion: "/merchant/order/cancel", // 取消c类订单订单


    dynamic_detail: '/member/merchantStore/pushDetails',//帖子详情
    product_detail: '/member/goods/detail',//商品详情
    product_banner: '/api/app/goods/goodsGalleryList',//商品详情
    comment_list: '/api/app/comment/list',//商品评价


  checkEmail: '/api/app/member/checkEmail',//原邮箱验证验证码

	cancelDetailsEdit: '/merchant/goods/cancelDetailsEdit', // 撤销编辑 or 发起撤销申请

  dismissalDetail: 'merchant/index/dismissalDetail', // 冻结一览

	exportCoupon: '/merchant/coupon/export', // 优惠券的导出

};
export default api;
   








// WEBPACK FOOTER //
// ./src/api/api.js